import React, { useEffect, useState } from 'react';
import { Avatar, Switch, Form, Input } from 'antd';
import { useSelector } from 'react-redux';
import { TurnOnOffMaintenanceApi, TurnOnOffMobileNoOfIBTreeApi, GetMaintenanceStatusApi, GetContactStatusApi, UpdateParentVisibilityApi, ForgetOtp2FAApi, Request2faChangeApi } from '../../api/request/header/maintenance';
import toast from 'react-hot-toast';
import ModalComponent from "../../components/global/modal/ModalComponent";
import LoadableButton from "../../components/buttons/LoadableButton"
import { useDispatch } from 'react-redux';
import { setUserDetails } from '../../store/Slices/userSlice';


export default function Profile({ isAdmin }) {
    const dispatch = useDispatch();
    const [formotp] = Form.useForm()
    const { userDetails } = useSelector(state => state.user);
    let isSalesManager = userDetails?.roleId === 6;
    const [checked, setChecked] = useState(false);
    const [contactChecked, setContactChecked] = useState(false);
    const [parentChecked, setParentChecked] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRequesting2FA, setIsRequesting2FA] = useState(false);
    const [isOpen2FAModal, setIsOpen2FAModal] = useState(false);
    const [FormData, setFormData] = useState({ otp: "" });
    const [qrCodeBase64, setQrCodeBase64] = useState("");
    const [secretKey, setSecretKey] = useState("");
    const [pending2faState, setPending2faState] = useState(null);

    const handleChange = async (checked) => {
        try {
            const { data } = await TurnOnOffMaintenanceApi(new URLSearchParams({ isEnabled: checked }).toString());
            if (data?.success) {
                setChecked(checked);
                toast.success(data?.message);
            }
        } catch (error) {
            if (error?.response?.data?.error?.messag) {
                toast.error(error?.response?.data?.error?.message);
            }
        }
    };

    const handleContacts = async (checked) => {
        try {
            const { data } = await TurnOnOffMobileNoOfIBTreeApi({ onOffMobileNo: checked });
            if (data?.success) {
                setContactChecked(checked);
                toast.success(data?.message);
            }
        } catch (error) {
            if (error?.response?.data?.error?.messag) {
                toast.error(error?.response?.data?.error?.message);
            }
        }
    }

    const getMaintenanceStatus = async () => {
        try {
            const { data } = await GetMaintenanceStatusApi();
            if (data?.success) {
                setChecked(data?.data);
            }
        } catch (error) { }
    }

    const getContactStatus = async () => {
        try {
            const { data } = await GetContactStatusApi();
            if (data?.success) {
                setContactChecked(data?.data?.isVisible);
            }
        } catch (error) { }
    }

    const handleParentChange = async (checked) => {
        try {
            const { data } = await UpdateParentVisibilityApi(userDetails?._id, new URLSearchParams({ status: checked }).toString());
            if (data?.success) {
                setParentChecked(checked);
                toast.success(data?.message);
            }
        } catch (error) {
            if (error?.response?.data?.error?.messag) {
                toast.error(error?.response?.data?.error?.message);
            }
        }
    }

    useEffect(() => {
        if (!isOpen2FAModal) {
            formotp.resetFields();
            setQrCodeBase64("");
            setSecretKey("");
            setPending2faState(null);
        }
    }, [isOpen2FAModal, formotp]);


    const handle2faToggle = async (isEnable) => {
        setIsRequesting2FA(true);
        try {
            const { data } = await Request2faChangeApi(isEnable);
            if (data?.success) {
                setQrCodeBase64(data?.data?.qrCodeBase64 || "");
                setSecretKey(data?.data?.secretKey || "");
                setPending2faState(isEnable);
                setIsOpen2FAModal(true);
                toast.success(data?.message);
            }
        } catch (err) {
            toast.error(err?.response?.data?.error?.message || err?.response?.data?.message);
        }
        finally {
            setIsRequesting2FA(false);
        }
    };


    const handleSubmit2FA = async (values) => {
        const { otp } = values;

        if (!otp) {
            toast.error("OTP can not be empty.");
            return;
        }

        try {
            setIsLoading(true);
            const isActiveFlag = pending2faState ?? !userDetails?.verifyWithOpt;
            let params = {
                userId: userDetails?._id,
                otp,
                isActiveFlag,
            };
            const { data } = await ForgetOtp2FAApi(params);

            if (data?.success) {
                toast.success(data?.message);
                dispatch(setUserDetails({ ...userDetails, verifyWithOpt: isActiveFlag }));
                formotp.resetFields();
                setIsOpen2FAModal(false);
            }

            setIsLoading(false);
        } catch (error) {
            toast.error(error?.response?.data?.error?.message || error?.response?.data?.message);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getContactStatus();
        getMaintenanceStatus();
    }, []);

    const onChange = (e) => {
        const newValue = e.target ? e.target.value : e;
        setFormData({ ...FormData, otp: newValue });
    };
    const sharedProps = {
        onChange,
    };

    return (
        <div>
            <div className='border rounded-lg flex justify-between items-start p-5'>
                <div className='flex items-center'>
                    <Avatar round size={60} src={userDetails?.profileImage} />
                    <div className='ml-4'>
                        <p className='font-medium text-lg'>{userDetails?.fullName}</p>
                        <p className='text-[#848484] text-lg mt-1'>{userDetails?.address}</p>
                    </div>
                </div>
            </div>

            <div className='border rounded-lg p-4 mt-4'>
                <p className='font-medium text-xl '>Personal Information</p>
                <div className='grid sm:grid-cols-2 grid-cols-1 mt-5 items-center gap-5'>
                    <div>
                        <p className='text-[#848484] font-normal text-base '>First Name</p>
                        <p className='text-[#848484] font-semibold text-base mt-1'>{userDetails?.firstName}</p>
                    </div>
                    <div className=''>
                        <p className='text-[#848484] font-normal text-base '>Lat Name</p>
                        <p className='text-[#848484] font-semibold text-base mt-1'>{userDetails?.lastName}</p>
                    </div>
                    <div>
                        <p className='text-[#848484] font-normal text-base '>Email Address</p>
                        <p className='text-[#848484] font-semibold text-base mt-1'>{userDetails?.email}</p>
                    </div>
                </div>
            </div>

            {(isAdmin && !isSalesManager) &&
                <div>
                    <div className='flex items-center border rounded-lg p-4 mt-4'>
                        <Switch
                            checkedChildren="ON"
                            unCheckedChildren="OFF"
                            checked={checked}
                            onChange={handleChange}
                        />
                        <p className='text-[#848484] font-semibold text-base ms-2'>Maintenance Mode</p>
                    </div>

                    <div className='flex items-center border rounded-lg p-4 mt-4'>
                        <Switch
                            checkedChildren="ON"
                            unCheckedChildren="OFF"
                            checked={contactChecked}
                            onChange={handleContacts}
                        />
                        <p className='text-[#848484] font-semibold text-base ms-2'>Show Contacts</p>
                    </div>

                    <div className='flex items-center border rounded-lg p-4 mt-4'>
                        <Switch checkedChildren="ON" unCheckedChildren="OFF" checked={parentChecked} onChange={handleParentChange} />
                        <p className='text-[#848484] font-semibold text-base ms-2'>Visible as Parent</p>
                    </div>
                    <div className='flex items-center border rounded-lg p-4 mt-4'>
                        <Switch
                            checkedChildren="ON"
                            unCheckedChildren="OFF"
                            checked={userDetails?.verifyWithOpt}
                            loading={isRequesting2FA}
                            onChange={handle2faToggle}
                        />
                        <p className='text-[#848484] font-semibold text-base ms-2'>Two Factor Authentication (2FA)</p>
                    </div>
                </div>
            }
            <ModalComponent isOpen={isOpen2FAModal} setIsOpen={setIsOpen2FAModal} title='Two Factor Authentication' width={600}>
                <div className='sm:grid grid-cols-12 justify-center items-center '>
                    <div className='md:col-span-12 col-span-5 flex flex-col bg-[#FFFFFF] justify-center items-center p-5 gap-6  w-full'>
                        <div className="text-center">
                            <p className="text-[#da3a3a] text-sm font-medium auth-com mt-2">
                                Scan the QR code with Google Authenticator app, or enter the key manually below.
                            </p>
                            {qrCodeBase64 ? (
                                <img
                                    className="mx-auto mt-6 h-48 w-48 object-contain rounded-md border border-[#e5e5e5] p-2"
                                    alt="Google Authenticator QR Code"
                                    src={qrCodeBase64?.startsWith("data:")
                                        ? qrCodeBase64
                                        : `data:image/png;base64,${qrCodeBase64}`}
                                />
                            ) : null}
                            {secretKey ? (
                                <div className="mt-4 text-center">
                                    <p className="text-[#b0b0b0] text-sm">Can't scan? Enter this key manually:</p>
                                    <p className="mt-2 text-sm font-semibold tracking-wide text-[#3a3a3a]">{secretKey}</p>
                                </div>
                            ) : null}
                            <p className="text-[silver] text-sm font-medium auth-com mt-4">
                                Please enter the OTP and verify yourself
                            </p>
                        </div>
                        <div className="w-full">
                            <Form autoComplete="off" form={formotp} onFinish={handleSubmit2FA}>
                                <div className="w-full text-sm py-1">
                                    <div className="relative">
                                        <Form.Item
                                            name="otp"
                                            rules={[
                                                {
                                                    required: true,
                                                },
                                            ]}
                                        >
                                            <Input.OTP
                                                {...sharedProps}
                                                style={{ width: '100%' }}
                                            />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className="mt-8">
                                    <LoadableButton type='submit' className='bg-primary text-[#FFFFFF] font-semibold text-lg rounded-lg w-full py-2 text' lable='Verify' isLoading={isLoading} loadingLable='Verifying...' disabled={isLoading} />
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </ModalComponent>
        </div>
    )
}